import Credits from './credits'

export default Credits
